var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Interfaces = OCS.Viewer.Interfaces || {};
OCS.Viewer.Functions = OCS.Viewer.Functions || {};
// Requires: LayerGroupInfo, LayerGroupLayer, LayerGroupLayerManipulation, OCS.Viewer.Interfaces.LayerGroupTime, OCS.Viewer.Interfaces.LayerGroupRequest
OCS.Viewer.Functions.define_layer_group_netcdf_interface = function () {
    OCS.Viewer.Interfaces.LayerGroupnetcdf = {
        init_netcdf_events: function () {
            this.addEvent('init', this.on_init_netcdf.bind(this));
        },
        on_init_netcdf: function () {
            // Setup and initialize the group by subscribing to the data manager.
            var dateObj = this.get_map_datetime_obj();
            var earliest_epoch_ts = dateObj.get_start_epoch_time();
            var latest_epoch_ts = dateObj.get_end_epoch_time();
            var start, end;


            var resolution = this.get_resolution();
            var init_start = this.options.init_start_timestamp_epoch;
            var init_end = this.options.init_end_timestamp_epoch;

            if (earliest_epoch_ts && earliest_epoch_ts > init_start) {
                start = earliest_epoch_ts;
            } else {
                start = init_start;
            }
            if (latest_epoch_ts && latest_epoch_ts > init_end) {
                end = latest_epoch_ts;
            } else {
                end = init_end;
            }

            start -= (start % resolution);
            end -= (end % resolution);

            for (var i = end; i >= start; i = i - resolution) {
                this.get_layer_source(i);
            }
            this.subscribe();
            this.fireEvent('show_current_layer', null, 1);

            if (this.init_time_events) {
                this.init_time_events();
            }
            if (this.show_current_frame_method) {
                this.show_current_frame_method();
            }
        },
        get_query_url: function(ops) {
            return this.get_dataset_obj().get_query_url(ops);
        },
        get_data_url: function(ops) {
            return this.get_dataset_obj().get_url(ops);
        }
    };
};
OCS.Viewer.Functions.define_layer_group_netcdf_interface();